const mutations = {
    setCollapse(state, isCollapse){
        state.isCollapse = isCollapse;
    },
    handleMyActiveTab(state, activeName){
        state.myAppraiseActiveTab = activeName
    },
    handleTeamActiveTab(state, activeName){
        state.teamAppraiseActiveTab = activeName
    },
    setLanguage(state,lang) {
        state.language = lang;
    },
    handleSetUserInfo(state, info) {
        state.userInfo = info
    },
    handleSetOATitle(state,title) {
        state.oaTitle = title;
    },
    handleSetMenus(state, data) {
        state.menus = data.menus;
        state.menuList = data.data
    },
    handleSetRoles(state, roles) {
        state.roles = roles
    },
    handleSetCurrentRole(state, currRole) {
        state.currentRole = currRole;
    },
    handleSetCurrentModule(state, moduleCode) {
        state.currentModule = moduleCode
    },
    SET_DEFAULTACTIVE(state, ids) {
        state.defaultActive = ids;
    },
    SET_REDIRECTURL(state, url) {
        state.redirectUrl = url;
    }
}
export default mutations